import * as React from 'react';
import * as classNames from 'classnames';

import bind from '../bind';

interface IProps {
  onSelect: Function;
  rating: number;
}

export default class StarRatingSelector extends React.Component<IProps, null> {
  @bind
  handleClick(evt) {
    evt.preventDefault();
    this.props.onSelect(+evt.target.dataset.idx);
  }

  @bind
  renderStar(idx) {
    const classes = classNames(
      'star-rating__selectable-star',
      { 'star-rating__selectable-star--selected': (idx <= this.props.rating) },
    );

    return (
      <button
        className={classes}
        onClick={this.handleClick}
        data-idx={idx}
        key={idx}
      />
    );
  }

  render() {
    const classes = classNames(
      'star-rating',
      'star-rating--selector',
      'star-rating--large',
    );

    return (
      <div className={classes}>
        { [1, 2, 3, 4, 5].map(this.renderStar) }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/star_rating_selector.tsx